module.exports = __webpack_public_path__ + "img/link.7d2fbe5f.png";